module.exports = __webpack_public_path__ + "files/70fbd08e3a5ca70d1be02f24b50b8191.png";